import RowProductPage from "./row-product-page";
import AddProductsModal from "./add-products-modal";
import {CircularProgress} from "material-ui";
import {Constants} from "../../../../constants";
import RedirectIfNotLogged from "../../../menu/redirect-if-not-logged";
import Header from "../../../header";
import TopActionsComponent from "../../../top-actions-component";
import request from "../../../../config/axios-config";
import * as ErrorAction from "../../../../redux/action/error-action";
import {connect} from "react-redux";

const React = require('react');

class ProductsPage extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            data: [],
            categories: [],
            showAdd: false,
            wasDataLoaded: false,
            emptyData: false,
        };
    }

    componentDidMount() {
        this.refreshData();
    }

    componentWillUnmount() {
        this.props.hideError();
        this.setState({wasDataLoaded: false});
    }

    getCategories = () => {
        request({
            url: Constants.SERVER_ENDPOINT + '/acquisition-category/all',
            method: "GET"
        }).then(json => {
            this.setState({
                categories: json.data,
                loadingData: false
            })
        }).catch(err => {
            this.props.showError("Incarcarea paginii a esuat. Va rog reincercati!");
            this.setState({loadingData: false});
        })
    };


    refreshData = () => {
        this.setState({loadingData: true});
        request({
            url: Constants.SERVER_ENDPOINT + '/product/all',
            method: "GET"
        }).then(response => {
            let isEmptyData = !response.data || response.data.length === 0;
            this.setState({
                data: response.data,
                wasDataLoaded: true,
                emptyData: isEmptyData
            });
            this.getCategories();
        }).catch(err => {
            this.setState({loadingData: false});
            this.props.showError("Incarcarea paginii a esuat. Va rog reincercati!");
        })
    };

    onDeleteClicked = (index, id) => {
        request({
            url: Constants.SERVER_ENDPOINT + '/product/delete/' + id,
            method: "post"
        }).then(json => {
            let newData = [...this.state.data];
            newData.splice(index, 1);
            this.setState({data: newData});
        }).catch(err => {
            this.props.showError("Stergerea a esuat. Va rog reincercati!");
        })
    };

    onAddClicked = () => {
        this.setState({
            showAdd: true,
            addTitle: "Adaugati produsul"
        });
        this.props.onDialogVisible(true);
    };

    addFinished = () => {
        this.setState({
            showAdd: false
        });
        this.refreshData();
        this.props.onDialogVisible(false);
    };

    onEditClicked = (id, name, unit, category, price, codeSsi) => {
        this.setState({
            showEdit: true,
            editId: id,
            name: name,
            unit: unit,
            price: price,
            selectedCategory: category,
            codeSsi: codeSsi,
            editTitle: "Editati produsul"
        });
        this.props.onDialogVisible(true);
    };

    editFinished = () => {
        this.setState({
            showEdit: false,
            editId: null
        });
        this.refreshData();
        this.props.onDialogVisible(false);
    };

    render() {

        let rows = this.state.data.map((t, i) => {
            return (
                <RowProductPage
                    key={t.id}
                    id={t.id}
                    index={i}
                    name={t.name}
                    category={t.category.name}
                    categoryId={t.category.id}
                    unit={t.measureUnit}
                    price={t.price}
                    codeSsi={t.codeSsi}
                    onDeleteClicked={this.onDeleteClicked}
                    onEditClicked={this.onEditClicked}
                />
            )
        });

        return (
            <div>
                <RedirectIfNotLogged/>


                {this.state.showAdd === true
                    /*Show ADD MODAL*/
                    ? <AddProductsModal
                        onCancel={this.addFinished}
                        title={this.state.addTitle}
                        categories={this.state.categories}
                    /> : ""
                }

                {this.state.showEdit === true && this.state.editId
                    ? <AddProductsModal
                        onCancel={this.editFinished}
                        title={this.state.editTitle}
                        id={this.state.editId}
                        name={this.state.name}
                        unit={this.state.unit}
                        price={this.state.price}
                        categories={this.state.categories}
                        selectedCategory={this.state.selectedCategory}
                        codeSsi={this.state.codeSsi}
                    />
                    : ""}


                <Header title={"Gestionare produse/servicii/lucrari"}/>

                {this.state.loadingData
                    ?
                    <div style={{textAlign: 'center'}}>
                        <CircularProgress/>
                    </div>
                    : this.state.emptyData
                        ? <div>
                            <div style={{float: 'right'}}>
                                <TopActionsComponent onAddClicked={this.onAddClicked}/>
                            </div>
                            <div className="ds-empty"><h3>Nu aveti produse!</h3></div>
                        </div>
                        : <div>
                            <div style={{width: '75%', margin: "0 auto"}}>
                                <div style={{float: 'right'}}>
                                    <TopActionsComponent onAddClicked={this.onAddClicked}/>
                                </div>
                                <div>
                                    <table className='table  table-hover'>
                                        <tbody>
                                        <tr>
                                            <th>Denumire</th>
                                            <th>Unitate Masura</th>
                                            <th>Categorie</th>
                                            <th>Pret Stabilit</th>
                                            <th>Code SSI</th>
                                            <th style={{width: 202}}>Edit/Delete</th>
                                        </tr>
                                        {rows}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                }
            </div>
        )
    }
}

function mapStateToProps(state, ownProps) {
    return {
        userDepartment: state.login.user.department,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        showError: (text) => dispatch(ErrorAction.showError(text)),
        hideError: () => dispatch(ErrorAction.hideError())
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ProductsPage)
